import React from "react";

const ChevronDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4 opacity-50"
      aria-hidden="true"
    >
      <path d="M6 9l6 6l6 -6"></path>
    </svg>
  );
};

export default ChevronDownIcon;
